module.exports = __webpack_public_path__ + "static/av.15c92b58.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/av.png
// module id = 3031
// module chunks = 199180123508537